<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      title="Position Group"
      text="Edit Position Group"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field
                v-model="positionGroup.name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Name"
              />
            </v-col>
            
            <v-col cols="12">
              <v-autocomplete
                v-model="positionCategory"
                v-validate="'required'"
                :error-messages="errors.collect('positionCategory')"
                :items="positionCategories"
                data-vv-name="positionCategory"
                data-vv-as="position category"
                item-text="name"
                multiple
                chips
                hide-selected
                hide-no-data
                deletable-chips
                item-value="id"
                label="Position Categories"
              />
            </v-col>

            <v-col cols="12">
              <v-autocomplete
                v-model="leaveEntitlementSetting"
                v-validate="'required'"
                :error-messages="errors.collect('leaveEntitlementSetting')"
                data-vv-name="leaveEntitlementSetting"
                data-vv-as="leave entitlement"
                :items="leaveEntitlementSettings"
                multiple
                chips
                hide-no-data
                hide-selected
                item-text="name"
                item-value="id"
                deletable-chips
                label="Leave Entitlement"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      positionGroup: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        // categories: [],
        // localPosition: null,
        positionCategory: [],
        positionCategories: [],
        leaveEntitlementSetting: [],
        leaveEntitlementSettings: [],
      }
    },
    watch: {
      dialog: function (value) {
        if (value) {
          this.loadPositionCategories()
          this.loadLeaveEntitlementSettings()

          this.positionGroup.position_categories.map(item => {
            this.positionCategory.push(item.id)
          })
          this.positionGroup.position_group_leave_entitlement_settings.map(item => {
            this.leaveEntitlementSetting.push(item.leave_entitlement_setting_id)
          })
        } else {
          this.positionCategory = []
          this.leaveEntitlementSetting = []
        }
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.positionGroups().update(this.positionGroup.id, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.dialog = false
                }
              })
              .catch(() => {})
              .then(() => {
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        return {
          name: this.positionGroup.name,
          positionCategories: this.positionCategory,
          leaveEntitlementSettings: this.leaveEntitlementSetting,
        }
      },

      loadPositionCategories () {
        this.$api.positionCategories().list()
          .then(res => {
            this.positionCategories = res.data
          })
      },

      loadLeaveEntitlementSettings () {
        this.$api.leaveEntitlementSettings().list()
          .then(res => {
            this.leaveEntitlementSettings = res.data
          })
      },
    },
  }
</script>
